import React, { useEffect, useState } from "react";
import { IconButton } from "@src/components/atoms/buttons/icon-button/icon-button";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import checkBoxIcon from "@src/assets/svg/checkbox-icon.svg";
import checkBoxCheckedIcon from "@src/assets/svg/checked-checkbox-icon.svg";
import styles from "./alarm-list-header.module.scss";
import { AlarmList } from "@src/cloud-connect/alarms/entities/alarm-list";
import { getAlarmProfiles } from "@src/cloud-connect/dependency-injection-container/get-alarm-profiles";
import { useI18N } from "@src/language/language-context";

const cssClassName = "alarm-list-header";

interface AlarmListHeaderProps {
  alarmListInstance: AlarmList;
}

export const AlarmListHeader = ({
  alarmListInstance,
}: AlarmListHeaderProps) => {
  const i18n = useI18N();
  const [checkboxState, setCheckboxState] = useState(false);

  const texts = {
    title: i18n("modules.alarmListHeader.title"),
    condition: i18n("modules.alarmListHeader.condition"),
    thresholds: i18n("modules.alarmListHeader.thresholds"),
    unit: i18n("modules.alarmListHeader.unit"),
    active: i18n("modules.alarmListHeader.active"),
  };

  const returnCheckboxIconByState = (checkboxState: boolean) => {
    return checkboxState ? checkBoxCheckedIcon : checkBoxIcon;
  };

  const handleClickOnCheckbox = () => {
    setCheckboxState(!checkboxState);
    alarmListInstance.toggleAllAlarmRowActive(!checkboxState);
  };

  useEffect(() => {
    const updateCheckBoxState = () => {
      setCheckboxState(false);
    };

    updateCheckBoxState();

    getAlarmProfiles().addObserver(updateCheckBoxState);

    return () => {
      getAlarmProfiles().removeObserver(updateCheckBoxState);
    };
  }, []);

  return (
    <div className={styles[cssClassName]}>
      <FlexRowContainer horizontalGap={4}>
        <IconButton
          icon={returnCheckboxIconByState(checkboxState)}
          fun={handleClickOnCheckbox}
        />
        <p className={styles[`${cssClassName}__text`]}>{texts.title}</p>
      </FlexRowContainer>
      <FlexRowContainer>
        <p className={styles[`${cssClassName}__text`]}>{texts.thresholds}</p>
      </FlexRowContainer>
      <FlexRowContainer>
        <p className={styles[`${cssClassName}__text`]}>{texts.unit}</p>
      </FlexRowContainer>
      <FlexRowContainer>
        <p className={styles[`${cssClassName}__text`]}>{texts.active}</p>
      </FlexRowContainer>
    </div>
  );
};
